/**
 * Display name/description for user groups.
 *
 * System default groups store a canonical English name and are identified by
 * `systemKey`; the display name follows the active language via the
 * userGroups.systemNames.* locale entries. Custom groups are user content and
 * render exactly as written — never translated.
 *
 * Safe to call on any entity: anything without a systemKey (departments,
 * positions, custom groups) falls through to its stored name.
 */
export const groupName = (g, t) => (
  g?.isSystem && g?.systemKey
    ? t(`userGroups.systemNames.${g.systemKey}`, { defaultValue: g.name })
    : g?.name
);

export const groupDesc = (g, t) => {
  if (!g?.isSystem) return g?.description;
  return g.systemKey === 'all-employees'
    ? t('userGroups.allEmployeesDesc')
    : t('userGroups.systemGroupDesc');
};
